import { render, staticRenderFns } from "./HerstellerComponent.vue?vue&type=template&id=3de58ea2&"
import script from "./HerstellerComponent.vue?vue&type=script&lang=js&"
export * from "./HerstellerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports